import { Component, Input, OnInit } from '@angular/core';
import { ContactDetailsService } from '../contact-details.service';
import { FormControl, Validators } from '@angular/forms';
import { NotificationService } from '../../shared/notification.service';
import { NumberValidator } from './number-details.validator';
import { HistoryService } from '../contact-history/history.service';
import { DetailsBox, MsisdnConfig } from '../contacts-details.model';
import * as moment from 'moment';
import { DATETIME_FORMATS } from '../../shared/utils/timeUtils';

@Component({
  selector: 'cc-number-details',
  templateUrl: './number-details.component.html',
  styleUrls: ['./number-details.component.scss']
})
export class NumberDetailsComponent implements OnInit {
  @Input() recordId: number;
  @Input() data: DetailsBox;
  public numbersConfig: MsisdnConfig;
  public newPrimaryNumber: FormControl;

  constructor(
    public contactDetailsService: ContactDetailsService,
    public notificationService: NotificationService,
    public historyService: HistoryService
  ) {}

  ngOnInit() {
    this.newPrimaryNumber = new FormControl(
      '',
      Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(20)]),
      [NumberValidator(this.contactDetailsService, this.recordId)]
    );

    this.refreshData();
  }

  refreshData() {
    this.contactDetailsService.getNumberDetailsData(this.recordId).subscribe((data: MsisdnConfig) => {
      this.numbersConfig = data;
    });
  }

  refreshRecordHistory(id = this.recordId) {
    this.historyService.refreshHistory(id);
  }

  save() {
    this.addPrimaryMsisdn(this.newPrimaryNumber.value);
    this.newPrimaryNumber.setValue('');
    this.newPrimaryNumber.markAsUntouched();
  }

  addPrimaryMsisdn(number) {
    this.numbersConfig.primaryMsisdn = number;
    this.contactDetailsService.addPrimaryMsisdn(this.recordId.toString(), { msisdn: number }).subscribe(
      msisdn => {
        this.notificationService.open('EVENT_DETAILS.CHANGED_PRIMARY_MSISDN');
        this.refreshData();
        this.refreshRecordHistory();
      },
      () => {
        this.refreshData();
      }
    );
  }

  isNumberValid() {
    return this.newPrimaryNumber.invalid || !this.newPrimaryNumber.dirty;
  }

  formatDate(date: string) {
    return moment(date).format(DATETIME_FORMATS.us);
  }

  getIsoCountry(number: string) {
    return this.historyService.getIsoCountry(number);
  }
}
